import { Select } from "antd";
import { RequiredIndicator } from "../../../components";

const { Option } = Select;

const AppointmentLocationSection = ({
  state,
  setState,
  facilityOptions,
  branchesForFacility,
  selectedFacilityName,
  selectedBranchName,
  isChangingLocation,
  setIsChangingLocation,
  useCurrentLocation,
  disabled = false,
}) => {
  return (
    <div className="border rounded p-4 mb-3">
      <h6 className="app-text-primary mb-3">Where</h6>
      {!isChangingLocation ? (
        <div>
          <p className="mb-1 fw-semibold">{selectedFacilityName}</p>
          <p className="mb-3 text-muted small">{selectedBranchName}</p>
          {!disabled && (
            <button
              type="button"
              className="button is-light is-primary"
              onClick={() => setIsChangingLocation(true)}
            >
              Change location
            </button>
          )}
        </div>
      ) : (
        <>
          <label className="mb-1" htmlFor="facilityId">
            Facility <RequiredIndicator />
          </label>
          <Select
            size="large"
            id="facilityId"
            showSearch
            className="w-100 mb-3"
            placeholder="Select facility"
            value={state.facilityId}
            disabled={disabled}
            onChange={(facilityId) => {
              setState((prev) => ({
                ...prev,
                facilityId,
                facilityBranchId: null,
                staffId: null,
              }));
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {facilityOptions.map((facility) => (
              <Option key={facility.id} value={facility.id}>
                {facility.name}
              </Option>
            ))}
          </Select>

          <label className="mb-1" htmlFor="facilityBranchId">
            Branch <RequiredIndicator />
          </label>
          <Select
            size="large"
            id="facilityBranchId"
            showSearch
            className="w-100 mb-3"
            placeholder="Select branch"
            value={state.facilityBranchId}
            disabled={disabled || !state.facilityId}
            onChange={(facilityBranchId) => {
              setState((prev) => ({ ...prev, facilityBranchId }));
            }}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {branchesForFacility.map((branch) => (
              <Option key={branch.id} value={branch.id}>
                {branch.name || branch.branchName || branch.location || branch.id}
              </Option>
            ))}
          </Select>

          <div className="d-flex flex-wrap gap-2">
            <button
              type="button"
              className="button is-light is-primary"
              onClick={() => setIsChangingLocation(false)}
            >
              Done
            </button>
            <button
              type="button"
              className="button is-light"
              onClick={useCurrentLocation}
            >
              Use current location
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AppointmentLocationSection;
